import jobsDataFallback from "./jobs-data.json";

export async function loadJobs() {
  try {
    const res = await fetch("/jobs-data.json", { cache: "no-store" });
    if (res.ok) {
      return res.json();
    }
  } catch (err) {
    console.warn("Using bundled jobs data after fetch failure:", err);
  }

  return jobsDataFallback;
}

export function findJobById(jobs, id) {
  return jobs.find(
    (job) => String(job.id).toLowerCase() === String(id).toLowerCase()
  );
}
